window.enableSinglePersonContact = function() {
  var $personBlocks;
  $personBlocks = $('.single-person');
  if ($personBlocks.length) {
    return $personBlocks.each(function() {
      var $contactList, $openContact, $this;
      $this = $(this);
      $openContact = $this.find('.single-person__open-contact');
      $contactList = $this.find('.single-person__contact-list');
      return $openContact.click(function() {
        $this = $(this);
        if ($this.hasClass('open')) {
          $this.removeClass('open');
          $this.find('i').removeClass('ion-chevron-up').addClass('ion-chevron-down');
          return $contactList.slideUp(300);
        } else {
          $this.addClass('open');
          $this.find('i').removeClass('ion-chevron-down').addClass('ion-chevron-up');
          return $contactList.slideDown(300);
        }
      });
    });
  }
};

$(document).ready(function() {
  return window.enableSinglePersonContact();
});

// ---
// generated by coffee-script 1.9.2